/**
 * Mock data for company applications in the SCAD system
 * Centralized data source to be used across all components
 */

export const companyApplicationsData = [
  {
    id: 1,
    name: 'Tech Solutions Inc.',
    industry: 'Information Technology',
    size: 'medium',
    email: 'hr@techsolutions.com',
    logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    applicationDate: '2025-04-15',
    status: 'pending',
    documents: [
      { name: 'Business License', type: 'PDF', size: '2.4 MB' },
      { name: 'Tax Registration', type: 'PDF', size: '1.8 MB' }
    ]
  },
  {
    id: 2,
    name: 'Data Insights Co.',
    industry: 'Data Analytics',
    size: 'large',
    email: 'careers@datainsights.com',
    logo: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    applicationDate: '2025-04-10',
    status: 'approved',
    documents: [
      { name: 'Business License', type: 'PDF', size: '1.9 MB' },
      { name: 'Tax Registration', type: 'PDF', size: '1.5 MB' }
    ]
  },
  {
    id: 3,
    name: 'App Innovators',
    industry: 'Mobile Development',
    size: 'small',
    email: 'jobs@appinnovators.com',
    logo: 'https://images.unsplash.com/photo-1572044162444-ad60f128bdea?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    applicationDate: '2025-04-05',
    status: 'rejected',
    documents: [
      { name: 'Business License', type: 'PDF', size: '2.1 MB' },
      { name: 'Tax Registration', type: 'PDF', size: '1.7 MB' }
    ]
  },
  {
    id: 4,
    name: 'Global Marketing',
    industry: 'Marketing',
    size: 'small',
    email: 'careers@globalmarketing.org',
    logo: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    applicationDate: '2025-04-01',
    status: 'pending',
    documents: [
      { name: 'Business License', type: 'PDF', size: '2.3 MB' },
      { name: 'Tax Registration', type: 'PDF', size: '1.6 MB' }
    ]
  },
  {
    id: 5,
    name: 'Software Solutions',
    industry: 'Software Development',
    size: 'corporate',
    email: 'recruiting@softwaresolutions.com',
    logo: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80',
    applicationDate: '2025-03-28',
    status: 'approved',
    documents: [
      { name: 'Business License', type: 'PDF', size: '2.2 MB' },
      { name: 'Tax Registration', type: 'PDF', size: '1.9 MB' }
    ]
  }
]; 